import React, { useState, useCallback, useContext, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import useEntitesTable from "./useEntitesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import { withStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import EditAlertRuleDialog from "./EditAlertRuleDialog";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { deleteAlertRule, getAlertRule } from "services/ConfigServices";
import { NotificationManager} from "react-notifications";
import "assets/css/customNotifications.css";
import ReactLoading from "react-loading";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import Edit from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

const LoadingDiv = styled.div`
  height: 20vh;
  width: 20vw;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  padding-top: 10vh;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const GroupCell = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;



const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);



const RTAlertRules = () => {
  const appContext = useContext(AdvancedSearchContext);
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const alertscreate = permis.includes("alerts_admin");
  const { groupInfoListById, setPage } = appContext;
  const {
    gridState,
    error,
    refreshTable,
    permissionList,
    viewList,
    setLoading,
  } = useEntitesTable();

  const [open, setOpen] = useState(false);

  const [id, setId] = useState("");
  const [type, setType] = useState("");
  const [predifinedrule, setPredifinedrule] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [active, setActive] = useState("");
  const [criticity, setCriticity] = useState("");
  const [groups, setGroups] = useState("");
  const [diffusion, setDiffusion] = useState("");
  const [category, setCategory] = useState("");
  const [desctext, setDesctext] = useState("");
  const [rule, setRule] = useState("");
  const [filters, setFilters] = useState("");
  const [filterType, setFilterType] = useState('1.0');
  const [granularity, setGranularity] = useState("");

  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();

  const fillButtons = [
    { color: "success", icon: Edit },
    { color: "danger", icon: Close },
  ].map((prop, key) => {
    return (
      <Button
        color={prop.color}
        className={classes.actionButton}
        key={key}
        onClick={prop.onClick}
      >
        <prop.icon className={classes.icon} />
      </Button>
    );
  });

  useEffect(() => {
    setPage('alertrules');
  }, []);

  let dataAlertRules = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  if (error) {
    return (
      <p>
        <span role="img" aria-label="Problem">
          🔧
        </span>{" "}
        Il semble y avoir une erreur...{" "}
        <button onClick={refreshTable()}>Relancer</button>
      </p>
    );
  }

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
      wrap: true,
      cell: (row) =>
        row.type == 0 ? (
          <div style={{ color: "#000000"}}>Personnalisée</div>
        ) : row.type == 1 ? (
          <div style={{ color: "#000000"}}>Prédéfinie</div>
        ) : <div style={{ color: "#000000"}}>Personnalisée</div>
    },
    {
      name: "Categorie",
      selector: (row) => row.category,
      sortable: true,
      wrap: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      wrap: true,
    },
    {
      name: "Criticité",
      selector: (row) => row.criticity,
      sortable: true,
      width: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) =>
        row.criticity == 0 ? (
          <div style={{ color: "#008083", fontWeight: "bold" }}>Information</div>
        ) : row.criticity == 1 ? (
          <div style={{ color: "#E3A322", fontWeight: "bold" }}>Avertissement</div>
        ) : row.criticity == 2 ? (
          <div style={{ color: "#FF8E55", fontWeight: "bold" }}>Important</div>
        ) : (
          <div style={{ color: "#FF432D", fontWeight: "bold" }}>Critique</div>
        ),
    },
    {
      name: "Diffusion",
      selector: (row) => row.diffusion,
      sortable: true,
      wrap: true,
      maxWidth: "12rem",
      cell: (row) => (
        <GroupCell>
          {row.diffusion?.email?.map((name) => {
            return (
              <div>{name}</div>
            );
          })}
          {row.diffusion?.sms?.map((name) => {
            return (
              <div>{name}</div>
            );
          })}
        </GroupCell>
      ),
    },
    {
      name: "Périmètre",
      selector: (row) => row.groups,
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <GroupCell>
          {row.groups?.map((groupid) => {
            return (
              <div>{groupInfoListById["" + groupid]}</div>
            );
          })}
        </GroupCell>
      ),
    },
    alertscreate ?
    {
      name: "Activation",
      selector: (row) => row.active,
      sortable: true,
      width: "8rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <CustomSwitch
              inputTitle={""}
              checkedState={row.active}
              handleSwitchChange={handleActivationSwitch(row)}
            />
          </div>
        </>
      )
    } : {},
    alertscreate ?
    {
      name: "Actions",
      sortable: true,
      width: "8rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Button
              color={"success"}
              //className={row.type == 1 ? classes.actionButton :  classes.actionButtonDisabled}
              className={classes.actionButton}
              onClick={editRule(row)}
              //disabled={row.type == 1 ? false :  true}
            >
              <Edit className={classes.icon} />
            </Button>

            <CustomDeleteButton
              deleteTitle={"Suppression de la règle"}
              deleteSubTitle={
                "Êtes-vous sûr de vouloir supprimer la règle ?"
              }
              handleSupprimer={deleteRuleSelected(row)}
            />
          </div>
        </>
      ),
    } : {},
  ];

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleActivationSwitch = (row) => async () => {
    let obj = dataAlertRules.find((o) => o.id === row.id);
    let idSelected = obj.id;

    obj.active = !obj.active;
    axios
      .put(
        getAlertRule(obj.id),
        {
          name : obj.name || "",
          description : obj.description || "",
          active : obj.active,
          criticity : obj.criticity || 0,
          groups : obj.groups || [],
          diffusion : obj.diffusion || {},
          category : obj.category || "",
          desctext : obj.desctext || {},
          rule : obj.rule || "",
          filters : obj.filters || {},
          type : obj.type || 0,
          predifinedrule : obj.predifinedrule,
          granularity : obj.granularity || "",
          filterType : obj.filterType || '1.0',
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification("success", "Règle modifié");
          refreshTable();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        refreshTable();
        setNotification("error", "Une erreur est survenue");
      });

  };

  const editRule = (row) => async () => {
    let obj = dataAlertRules.find((o) => o.id === row.id);
    let idSelected = obj.id;

    handleClickOpen();
    setId(obj?.id);
    setType(obj?.type);
    setPredifinedrule(obj?.predifinedrule);
    setName(obj?.name);
    setDescription(obj?.description);
    setActive(obj?.active);
    setCriticity(obj?.criticity);
    setGroups(obj?.groups);
    setDiffusion(obj?.diffusion);
    setCategory(obj?.category);
    setDesctext(obj?.desctext);
    setRule(obj?.rule);
    setFilters(obj?.filters);
    setFilterType(obj?.filterType);
    setGranularity(obj?.granularity);
  };

  const deleteRuleSelected = (row) => async () => {
    setLoading(true);
    let obj = dataAlertRules.find((o) => o.id === row.id);
    let idSelected = obj.id;
    axios
      .delete(deleteAlertRule(idSelected), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200)
          NotificationManager.success("La règle a bien été supprimé");
        else NotificationManager.error("Un problème est survenu");
        refreshTable();
      });
  };

  return (
    <>
      <div style={{ paddingTop: 10 }}>
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          noDataComponent={<NoData>Aucune règle à afficher</NoData>}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          paginationComponentOptions={{
            noRowsPerPage: false,
            rowsPerPageText: "Lignes par page",
            rangeSeparatorText: "sur",
            selectAllRowsItem: false,
            selectAllRowsItemText: "Selectionner toutes les lignes",
          }}
          progressPending={gridState.loading}
          progressComponent={
            <div>
              <LoadingDiv>
                <ReactLoading
                  type={"bars"}
                  color={"#91c241"}
                  height={"10%"}
                  width={"10%"}
                />
              </LoadingDiv>
            </div>
          }
          {...gridState}
        />

        <Dialog
          onClose={handleClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth={true}
          maxWidth="lg"
          open={open}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleClose}>
            Modifier la règle
          </CustomDialogTitle>
          <DialogContent dividers>
            <EditAlertRuleDialog
              closeModal={handleClose}
              name={name}
              id={id}
              type={type}
              predifinedrule={predifinedrule}
              groups={groups}
              description={description}
              active={active}
              criticity={criticity}
              diffusion={diffusion}
              category={category}
              desctext={desctext}
              rule={rule}
              filters={filters}
              filterType={filterType}
              granularity={granularity}
              setLoading={setLoading}
              setNotification={setNotification}
              refetch={refreshTable}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
      
    </>
  );
};

export default RTAlertRules;
